import path from "node:path";

import express from "express";
import multer from "multer";

import { supportController } from "../controllers/support-controller";
import { authenticate } from "../middleware/auth-middleware";

const router = express.Router();

// Configure multer for file uploads
const storage = multer.diskStorage({
  destination: (_req, _file, cb) => {
    cb(null, "uploads/documents");
  },
  filename: (_req, file, cb) => {
    const uniqueSuffix = `${Date.now()}-${Math.round(Math.random() * 1e9)}`;
    cb(null, `${uniqueSuffix}${path.extname(file.originalname)}`);
  },
});

const upload = multer({
  storage,
  limits: {
    fileSize: 10 * 1024 * 1024, // 10MB
  },
  fileFilter: (_req, file, cb) => {
    const allowedTypes = /jpeg|jpg|png|gif|pdf|doc|docx|txt|zip/;
    const extname = allowedTypes.test(
      path.extname(file.originalname).toLowerCase(),
    );
    const mimetype = allowedTypes.test(file.mimetype);

    if (mimetype && extname) {
      cb(null, true);
      return;
    }
    cb(new Error("Only images, PDFs, documents, and zip files are allowed"));
  },
});

// User routes
router.post(
  "/tickets",
  authenticate,
  upload.array("attachments", 5),
  (req, res) => supportController.createTicket(req, res),
);

router.get("/tickets", authenticate, (req, res) =>
  supportController.getUserTickets(req, res),
);

router.get("/tickets/:id", authenticate, (req, res) =>
  supportController.getTicketDetails(req, res),
);

router.post(
  "/tickets/:id/messages",
  authenticate,
  upload.array("attachments", 5),
  (req, res) => supportController.addMessage(req, res),
);

router.put("/tickets/:id/close", authenticate, (req, res) =>
  supportController.closeTicket(req, res),
);

// Admin routes
router.get("/admin/tickets", authenticate, (req, res) =>
  supportController.getAllTickets(req, res),
);

router.post(
  "/admin/tickets/:id/reply",
  authenticate,
  upload.array("attachments", 5),
  (req, res) => supportController.replyToTicket(req, res),
);

export default router;
